import axios from 'axios';
import { toast } from 'sonner';
import { safePrintWindow, escapeHtml } from '../../utils/printUtils';
import { THERMAL_CSS, THERMAL_HEAD } from './nursingEntriesPrint';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const r = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
const fmtDate = (s) => new Date(`${s}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' });
const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true }) : '');
const row = (k, v, cls = '') => `<tr class="${cls}"><td>${k}</td><td class="n">${v}</td></tr>`;

const buildHtml = (d) => {
  const s = d.saved || {};
  const doc = (s.locked && s.doctor_auto) || d.doctor_auto || {};
  const nur = (s.locked && s.nursing_auto) || d.nursing_auto || {};
  const ph = s.pharmacy_manual || {};
  const cash = s.cash_manual || {};
  const fin = s.final_override || {};
  const rl = d.reception_loss || {};
  const pl = d.pharmacy_loss;
  const services = Object.entries(nur.services || {});

  let nurLoss = 0;
  const pharmRows = [];
  if (s.locked) {
    [['OP', 'op'], ['ER', 'er'], ['Review', 'review']].forEach(([label, k]) => {
      const x = pl?.[k];
      if (x && x.missed) pharmRows.push(row(`${label} missed ${x.missed} (sys ${x.system} / ph ${x.pharmacy})`, r(x.loss)));
    });
    services.forEach(([k, v]) => {
      const missed = Math.max(0, v.count - ((ph.nursing_services || {})[k] || 0));
      if (!missed) return;
      const loss = missed * (v.count ? v.revenue / v.count : 0);
      nurLoss += loss;
      pharmRows.push(row(`${escapeHtml(v.name)} missed ${missed}`, r(loss)));
    });
  }
  const pharmLoss = (pl?.total_loss || 0) + nurLoss;
  const sysTotal = (doc.total_amount || 0) + (nur.total_amount || 0);
  const counted = (cash.consultation_cash || 0) + (cash.nursing_cash || 0);

  return `${THERMAL_HEAD}<div class="hr"></div>
  <div class="c b">DAY END TALLY</div><div class="c">${fmtDate(d.date)}</div>
  <div class="c b">${s.locked ? `SIGNED: ${escapeHtml(s.signed_by)} &bull; ${fmtTime(s.submitted_at)}` : '** DRAFT - NOT SIGNED **'}</div><div class="hr"></div>

  <div class="sec">System Amount</div>
  <table>${row(`Consultation (OP ${doc.op_count || 0} / ER ${doc.er_count || 0} / Rev ${doc.review_count || 0})`, r(doc.total_amount))}
    ${row(`Nursing (${nur.total_entries || 0} entries)`, r(nur.total_amount))}
    ${row('SYSTEM TOTAL', r(sysTotal), 'tot')}</table>

  <div class="sec">Pharmacy Reconciled</div>
  ${s.locked ? `<table>${row('Consultation (pharmacy)', r(fin.consultation_total))}${row('Nursing (pharmacy)', r(fin.nursing_total))}
    ${row('FINAL TOTAL', r(fin.grand_total), 'tot')}${row('Cash counted', r(counted))}</table>` : '<div>Not reconciled yet</div>'}

  <div class="sec">Token Missed</div>
  <table>${row(`Not seen ${rl.stranded || 0} &bull; Deleted ${rl.deleted || 0}`, r(rl.loss_amount))}</table>

  <div class="sec">Pharmacy Missed</div>
  ${s.locked ? `<table>${pharmRows.join('') || row('None', r(0))}${row('PHARMACY LOSS', r(pharmLoss), 'tot')}</table>` : '<div>-</div>'}
  <div class="hr"></div>
  <table>${row('<b>TOTAL LOSS</b>', `<span class="loss">${r((rl.loss_amount || 0) + (s.locked ? pharmLoss : 0))}</span>`)}</table>
  ${s.discrepancy_note ? `<div class="hr"></div><div><b>Note:</b> ${escapeHtml(s.discrepancy_note)}</div>` : ''}
  <div class="sig"><span>Staff</span><span>Doctor</span></div>
  <div class="c" style="font-size:12px;margin-top:6px">Printed ${fmtTime(new Date().toISOString())}</div>`;
};

export const printDayEndReport = async (token, dateStr) => {
  try {
    const { data } = await axios.get(`${API}/daily-tally/report`, {
      params: dateStr ? { date_str: dateStr } : {},
      headers: { Authorization: `Bearer ${token}` },
    });
    safePrintWindow(`Day End Tally ${data.date}`, `<style>${THERMAL_CSS}</style>${buildHtml(data)}`);
  } catch (e) {
    toast.error(e?.response?.data?.detail || 'Could not load day-end report');
  }
};
